var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe_container"},[_c('vue-friendly-iframe',{ref:"friendlyIframe",attrs:{"src":_vm.link,"allowfullscreen":"allowfullscreen"},on:{"load":_vm.onLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }